import { Component } from '@angular/core';

@Component({
  selector: 'termos',
  templateUrl: 'termos.html'
})
export class TermosPage {
	constructor() {}
}


// WEBPACK FOOTER //
// ./src/pages/termos/termos.ts